import {ApiClientService} from '@dofleini/security';
import {EXPIRE_DATE_KEY, REFRESH_TOKEN_KEY, SPACE_KEY} from '../constants/storage.variables';

export const setAuthData = (data = {}) => {
  const {accessToken, refreshToken, space} = data;
  window.localStorage.setItem(ApiClientService.ACCESS_TOKKEN_KEY, accessToken);
  window.localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  window.localStorage.setItem(SPACE_KEY, space);
  window.localStorage.setItem(EXPIRE_DATE_KEY, new Date().toISOString());
};

// eslint-disable-next-line no-unused-vars
const getExpirationTime = () => window.localStorage.getItem(EXPIRE_DATE_KEY);

export const handleUserResponse = ({data}) => {
  setAuthData(data);
  return data;
};

export const getAuthInfo = () => {
  const token = window.localStorage.getItem(ApiClientService.ACCESS_TOKKEN_KEY);
  const refresh = window.localStorage.getItem(REFRESH_TOKEN_KEY);
  const space = window.localStorage.getItem(SPACE_KEY);
  return {
    token,
    refresh,
    space
  };
};
